<div class="proof-tracking">
    <div class="container">
        <dp-card>
            <p>
                Acompanhe abaixo o status da sua solicitação de confirmação de dados:
            </p>
        </dp-card>

        <div class="proof-tracking__wrapper mb-4">
            <div class="proof-tracking__row">
                <dp-tracking-status [first]="true" [active]="true" [title]="'Solicitação aberta'" [index]="1"></dp-tracking-status>
                <div class="status-separator"></div>
                <dp-tracking-status [active]="true" [title]="'Analisando informações'" [index]="2"></dp-tracking-status>
                <div class="status-separator"></div>
                <dp-tracking-status
                    [last]="true"
                    [active]="status === 'APROVADO'"
                    [title]="'Análise concluída'"
                    [index]="3"
                ></dp-tracking-status>
            </div>

            <p class="mt-5 mb-2">
                Seus dados foram enviados para análise e, em <b>até 2 (dois) dias úteis</b>, nós concluiremos a confirmação dos seus
                dados. <b>Fique atento à Caixa de Entrada do e-mail cadastrado</b>, pois enviaremos notificações sobre o andamento da
                sua solicitação.<br /><br />
              <small class="text-muted">
                <dp-button-certificate text="clique aqui." btnClass="text-secondary">
                      Caso você possua Certificado Digital, e não queira aguardar o prazo de aprovação,
                </dp-button-certificate>
              </small>
            </p>
        </div>
    </div>
</div>
